<template>
  <div class="insunet-modal">
    <transition name="fade">
    <div class="modal" v-bind:style="{ zIndex: zIndex }" @click="clickModal" v-show="visivility">

      <div class="body" style="">
        <div class="inner">
          <slot></slot>
        </div>
      </div>

    </div>
    </transition>
  </div>
</template>

<script>
export default {
  props : [ "visible", "zIndex" ],
  data(){
    return {
      visivility : false
    }
  },
  mounted(){
    if( this.$props.visible ) this.visivility = this.$props.visible
  },
  methods : {
    init(){

    },
    show() {
      if( Array.from( document.body.classList ).indexOf( 'modal-open' ) < 0 ) document.body.classList.add( "modal-open" );
      this.visivility = true;
    },
    close() {
      document.body.classList.remove( "modal-open" );
      this.visivility = false;
    },
    clickModal(e)
    {
      // 창닫는 부분 처리
      if( Array.from(e.target.classList).indexOf("modal-closer") >= 0 ) this.close();
    }
  }
}
</script>
